import type { Transaction } from '@domain/finance'

/**
 * O selo de "ainda não fechou".
 *
 * ## Ele não revela nada — as pendentes SEMPRE apareceram
 *
 * A ingestão já converte `PENDING` da Pluggy em `status: 'pending'`, e nenhuma
 * consulta as filtra: a única exclusão em qualquer lugar é `canceled`. Medido em
 * produção — 187 das 1.891 transações de cartão estavam pendentes, e as 27 que
 * chegaram depois do backfill estavam **todas** pendentes, porque o banco só as
 * fecha quando a fatura fecha.
 *
 * O que faltava não era mostrá-las. Era dizer que elas ainda podem mudar: o
 * valor de uma pendente muda (gorjeta de restaurante, ajuste de posto), a
 * descrição muda, e ela pode sumir. Sem o selo, uma compra que aparece hoje por
 * R$ 50 e amanhã por R$ 58 parece defeito do app.
 *
 * ## A cor é `--pendente`, e este é o primeiro uso dela
 *
 * O token existe desde o começo, descrito em `Tokens.md` como *"o olho:
 * pendência — a classificar, fatura aberta, o que espera decisão"*, e nenhum
 * componente o tinha usado. É literalmente este caso.
 *
 * Ela não é `--brand`, e a diferença importa: a regra do selo de status em Notas
 * (decisão 254b) é *cor só para o que pede alguma coisa*. Uma pendente não pede
 * nada — ela **avisa**. Pintá-la com o tom da marca a colocaria no mesmo balde
 * de "faça algo aqui".
 */
export function SeloPendente({ status }: { status: Transaction['status'] }) {
  if (status !== 'pending') return null
  return (
    <span className="shrink-0 text-[11px]" style={{ color: 'var(--pendente)' }}>
      pendente
    </span>
  )
}
